<template>
    <div>
        <el-form-item label="Opis" required
                      :error="errors[addLanguageSuffix('content')]">
            <wyswig-input v-model="form[addLanguageSuffix('content')]"/>
        </el-form-item>
    </div>
</template>
<script>
    export default {
        props: ['form', 'errors']
    }
</script>
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// TextWidget.vue?28fdad41